import { Box, TextField } from "@mui/material";
import Button from "@mui/material/Button";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogTitle from "@mui/material/DialogTitle";
import Slide from "@mui/material/Slide";
import React, { useState } from "react";
import { Formik } from "formik";
import { useAlert } from "react-alert";
import * as yup from "yup";
import { useNavigate } from "react-router-dom";
import categoryApiRoutes from "../../../utils/api/categoryApiRoutes";
const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});
const _initValues = {};

const CategoryModalForm = ({ open, handleClose }) => {
  const [name, setName] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  const alert = useAlert();
  const navigate = useNavigate();

  const initialValues = {
    name,
  };

  const formSchema = yup.object().shape({
    name: yup.string().required("Le nom ne doit pas être nul"),
  });

  const handleCategoryForm = async (values) => {
    setIsLoading(true);
    console.log(values);
    const apiResponse = await categoryApiRoutes.createCategory(values);
    if (!Object.keys(apiResponse).includes("error")) {
      console.log("Catégorie créee",apiResponse);
      setIsLoading(false);
      alert.success("Création de la catégorie réussit");
      handleClose();
    } else {
      setIsLoading(false);
      alert.error("Une érreur a été rencontrée");
    }
  };

  const updateCategory = async (id, category) => {
    setIsLoading(true)
    const apiResponse  = await categoryApiRoutes.update(id, category)
    if(!Object.keys(apiResponse).includes('error')){
      setIsLoading(false)
        alert.success(
          <div style={{ textTransform: 'none' }}>
            Mise à jour réussit
          </div>
        )
    }else{
      setIsLoading(false)
      alert.error(
        <div style={{ textTransform: 'none' }}>
          Echec de la mise à jour
        </div>
      )
    }

  }

  return (
    <Dialog
      open={open}
      TransitionComponent={Transition}
      keepMounted
      onClose={handleClose}
      aria-describedby="alert-dialog-slide-description"
      fullWidth={"sm"}
      maxWidth={"sm"}
    >
      <DialogTitle textAlign={"center"}>{"Créer la catégorie"}</DialogTitle>

      <DialogContent 
      >
        <Formik
          onSubmit={handleCategoryForm}
          initialValues={_initValues || initialValues}
          validationSchema={formSchema}
        >
          {({
            errors,
            values,
            touched,
            handleBlur,
            handleSubmit,
            handleChange,
          }) => (
            <form onSubmit={handleSubmit}>
              <TextField
                margin="normal"
                label="Nom"
                fullWidth
                variant="outlined"
                size="small"
                name="name"
                value={values.name}
                onChange={handleChange}
                onBlur={handleBlur}
                error={!!touched.name && !!errors.name}
                helperText={touched.name && errors.name}
              />
              <DialogActions>
                <Button onClick={handleClose} variant="contained">
                  Annuler
                </Button>
                <Button type="submit" color="secondary" variant="contained">
                  Créer
                </Button>
              </DialogActions>
            </form>
          )}
        </Formik>
      </DialogContent>
    </Dialog>
  );
};

export default CategoryModalForm;
